import * as React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { TextField } from '@mui/material';
import { useNotify } from '../landing-page/components/Utils';
import { useNavigate } from 'react-router-dom';





function ForgotPassword({ open, handleClose }) {

  const [loading, setLoading] = React.useState(false)
  const [email_, setEmail] = React.useState(null)
  const notify = useNotify();
  const navigate = useNavigate()

  const getLinkForReset = async() => {

    setLoading(true)
    try {
    const fetching = await fetch(`${process.env.REACT_APP_API_URL}/forgotpassword`, {
          "method": "POST",
          "body": JSON.stringify({email: email_}),
          "headers": {
                    "Content-Type": "application/json",
                },

        })
    const resp = await fetching.json()
    if (fetching.ok) {
      notify({
        message: resp,
        duration: 2000,
        variant: "success"

      })
      handleClose();
      // navigate("/");

    }
    else {
      notify({
        message: resp,
        variant: "warning",
        duration: 2000
      })
    }

  }
  catch (error) {
    notify({message: "cant sync with server please try again later",variant: "error",duration:2000})
  }
  finally {
    setLoading(false)
  }
}

  return (
   <Dialog open={open} onClose={handleClose} sx={{ backgroundImage: 'none' }}>
    <DialogTitle>Reset password</DialogTitle>

      <DialogContent
        sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}
      >
        <DialogContentText>
          Enter your account&apos;s email address, and we&apos;ll send you a link to
          reset your password.
        </DialogContentText>
          <TextField
          component='form'
          autoFocus
          required
          margin="dense"
          id="reset-email"
          name="reset-mail"
          label="Email address"
          type="email"
          fullWidth
          onChange={(e) => setEmail(e.target.value)}
        />
        
      </DialogContent>
      <DialogActions sx={{ pb: 3, px: 3 }}>
        <Button disabled={loading} onClick={handleClose}>Cancel</Button>
        <Button loading={loading} variant="contained" onClick={getLinkForReset}>
          Continue
        </Button>
      </DialogActions>
  </Dialog>
  )
  };


ForgotPassword.propTypes = {
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  };

export default ForgotPassword;